// ============================================================================
// OBT — Kampanya ARŞİVLEME onay diyaloğu (geri-alınabilir soft-delete)
// ============================================================================
// Backend sözleşmesi: POST /obt/campaigns/{id}/archive. Arşivleme GERİ ALINABİLİR
// (kayıt+denetim korunur, aktif listeden düşer); yetki backend'de yayın-anı
// immutable kaydından (yayınlayan ya da oluşturan) çözülür. Bu diyalog yalnız
// UX onayıdır; nihai yetki/kural kontrolü sunucudadır.
// ============================================================================

import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2, Archive } from 'lucide-react';
import { archiveCampaign } from './campaignApi';
import { normalizeObtError } from '../obtErrors';

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {{campaign_id:string, title?:string}|null} props.campaign
 * @param {() => void} props.onClose
 * @param {() => void} [props.onArchived]  Başarı sonrası (liste yenileme vb.)
 */
export default function ArchiveCampaignDialog({ open, campaign, onClose, onArchived }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Diyalog her açıldığında durumu sıfırla. Bu diyalog kalıcı olarak mount'lu
  // olduğundan (CampaignListView open prop'uyla açar/kapatır), başarılı bir
  // arşivlemeden sonra `submitting` sıfırlanmazsa bir sonraki bilgi talebi için
  // açıldığında buton pasif (silik) kalır ve işlem takılırdı. Kardeş diyaloglarla
  // (Delete/HardDelete/ExtendDue) aynı sıfırlama deseni.
  useEffect(() => {
    if (open) {
      setSubmitting(false);
      setError(null);
    }
  }, [open]);

  const handleArchive = async () => {
    if (!campaign?.campaign_id || submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      await archiveCampaign(campaign.campaign_id);
      if (onArchived) onArchived();
      onClose();
    } catch (e) {
      setError(normalizeObtError(e));
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o && !submitting) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Bilgi talebini arşivle</DialogTitle>
          <DialogDescription>
            {campaign?.title ? `“${campaign.title}” bilgi talebi` : 'Bilgi talebi'} aktif
            listeden kaldırılacak. Tüm kayıt ve geçmiş korunur; istediğinizde
            <strong> Arşiv</strong> sekmesinden geri alabilirsiniz.
          </DialogDescription>
        </DialogHeader>

        {error && (
          <p className="text-sm text-red-600" role="alert">
            {error.message || 'Bilgi talebi arşivlenemedi.'}
          </p>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={submitting}>
            Vazgeç
          </Button>
          <Button onClick={handleArchive} disabled={submitting}>
            {submitting ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />
            ) : (
              <Archive className="mr-2 h-4 w-4" aria-hidden="true" />
            )}
            Arşivle
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
